import { useEffect, useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import { useForm } from 'react-hook-form'
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from 'react-query'
import { SchemaValidationUpdate } from "../services/schemaValidation";
import { ValidateErrorMessage } from "components/ValidateErrorMessage";
import FlexibleWidthDialog from "components/Dialog/FlexibleWidthDialog"
import { edit } from "../services/api";
import DialogImageManager from "routes/ImageManager/DialogImageManager";
import FormBuilder from "components/Inputs/FormBuilder";
import { useTranslation } from "react-i18next";
import { DataFields } from "../Add/DataFields";
import { isEmptyObject } from "helpers";

export default function Edit({ open, close, instance, reportAction, extraData }) {
  const { t } = useTranslation();
  const globalUser = JSON.parse(localStorage.getItem('mqadusr'))
  const [isLoading, setIsLoading] = useState(false)
  const [dataInstance, setDataInstance] = useState({})
  const [imageManagerModalOpen, setImageManagerModalOpen] = useState(false)
  const [dataFieldImageManager, setDataFieldImageManager] = useState(null)
  let { reset, handleSubmit, register, formState: { errors }, setValue }  = useForm({ 
    resolver: yupResolver(SchemaValidationUpdate(t))
  })

  useEffect(() => {
    delete instance.password
    if(open) { setDataInstance(instance); reset(instance); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  const mutation = useMutation(edit, {
    onSuccess: (data) => {
      setIsLoading(false)
      if(data.status === "error") { reportAction(false, 'Error al guardar los datos', 'error')
      } else { 
        reset(); setDataInstance({});
        reportAction(true, 'Acción realizada correctamente', 'success') 
      }
    }
  })

  const handleEdit = (params) => {
    setIsLoading(true)
    let id = params._id
    delete params._id
    delete params.permissions
    delete params.verified
    delete params.companies
    delete params.deleted
    delete params.createdAt
    delete params.updatedAt
    delete params.deletedAt
    mutation.mutate({ id, params })
  }
  
  const handleClose = () => { reset(); setDataInstance({}); close() }

  const handleOnChangeData = (event) => { 
    if(event.target.name.includes(".")) {
      const separate = event.target.name.split(".")
      setDataInstance({ ...dataInstance, [separate[0]]: { ...dataInstance[separate[0]], [separate[1]]: event.target.value } })
      return;
    }
    setDataInstance({ ...dataInstance, [event.target.name]: event.target.value })
  }

  const handleChangeBoolean = (name) => {
    setDataInstance({...dataInstance, [name]: !dataInstance[name]}) 
  }

  /*Handlers Image manager */
  const handleOpenImageManager = () => { setImageManagerModalOpen(true) }  
  const handleCloseImageManager = ( prop ) => { setImageManagerModalOpen(prop) }
  const handleFieldImageManager = ( prop ) => { setDataFieldImageManager(prop) }  
  const handleSelectImageManager = (url) => {
    setDataInstance({...dataInstance, [dataFieldImageManager]: url})
    setValue(dataFieldImageManager, url)
  }

  const handleChangeMultiSelect = (event, field) => {
    const { target: { value } } = event;
    setDataInstance({ ...dataInstance, [field]: typeof value === 'string' ? value.split(',') : value })
  }

  const Actions = () => (<>
    { !isLoading ? <>
      <Button onClick={handleClose}>{t("button_text_cancel")}</Button>
      <Button variant="contained" color="info" onClick={handleSubmit(handleEdit)} disabled={isEmptyObject( dataInstance)} >{t("button_text_edit")}</Button>
      </> : <CircularProgress /> }
  </>)

  return (<>
    <FlexibleWidthDialog open={open} title={t('users_dialog_title_edit')} actions={<Actions />}>
      <>
        <input type="hidden" name="company" {...register(`company`)} value={globalUser.company._id}/>
        <ValidateErrorMessage message={errors.company?.message} />
        <FormBuilder
          dataDields={DataFields(t)}
          dataInstance={dataInstance}
          containerSelectOptions={{ roles: extraData.rolesList, branch_offices: extraData.branchOfficesList }}
          register={register}
          errors={errors}
          changeDataFunction={handleOnChangeData}
          changeDataMultiSelect={handleChangeMultiSelect}
          changeDataBoolean={handleChangeBoolean}
          openImageManager={handleOpenImageManager}
          setFieldImageManager={handleFieldImageManager} />
      </>
    </FlexibleWidthDialog>
    <DialogImageManager open={ imageManagerModalOpen } 
      actionClose={ handleCloseImageManager } 
      setImageSelected={ handleSelectImageManager } />
  </>)
}